import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  //IconButton,
} from "@mui/material";
import { ArrowLeftIcon } from "./icons";
import MoreVertIcon from "@mui/icons-material/MoreVert";
//import { useTranslation } from "react-i18next";
import { useStyles } from "./style";

interface Row {
  wait: string;
  request: string;
  state: string;
}

interface RequestsTableProps {
  data: Row[];
}

export const RequestsTable: React.FC<RequestsTableProps> = ({ data }) => {
  //const { t } = useTranslation();
  const classes = useStyles();

  const [selectedRow, setSelectedRow] = useState<number | null>(null);

  const handleRowClick = (index: number) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHead}>Wait</TableCell>
            <TableCell className={classes.tableHead}>Request</TableCell>
            <TableCell className={classes.tableHead}>State</TableCell>
            <TableCell className={classes.tableHead}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={index}
              onClick={() => handleRowClick(index)}
              sx={{
                cursor: "pointer",
                border: selectedRow === index ? "2px solid #1C9BCD" : "none",
                position: "relative",
              }}
            >
              <TableCell
                className={`${classes.cell} ${
                  selectedRow === index ? classes.selectedCell : ""
                }`}
              >
                {row.wait}
              </TableCell>
              <TableCell
                className={`${classes.cell} ${
                  selectedRow === index ? classes.selectedCell : ""
                }`}
              >
                {row.request}
              </TableCell>
              <TableCell
                className={`${
                  row.state === "Done" ? classes.cellDone : classes.cell
                } ${selectedRow === index ? classes.selectedCell : ""}`}
              >
                {row.state}
              </TableCell>
              <TableCell
                className={`${classes.cell} ${
                  selectedRow === index ? classes.selectedCell : ""
                }`}
                align="center"
              >
                {row.state === "Done" ? (
                  <MoreVertIcon />
                ) : (
                  <ArrowLeftIcon width={42} height={36} />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
